import Axios from "axios";
import dayjs from "dayjs";
import { API_URL } from "../../../DesktopApp";
import { encode } from "html-entities";

// const date = dayjs().format('YYYY-MM-DD HH:mm:ss');

const getAllCandidateSourceList = async (data) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/getCandidateSource`
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getAllCandidatePositionList = async (data) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/getCandidatePosition`
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getAllCandidateStatusList = async (data) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/getCandidateStatus`
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getAllBrokerList = async (data) => {
  try {
    const response = await Axios.post(`${API_URL}/dynamicFields/getBroker`);
    return response;
  } catch (err) {
    return err;
  }
};

const getAllLeadStatusList = async (data) => {
  try {
    const response = await Axios.post(`${API_URL}/dynamicFields/getLeadStatus`);
    return response;
  } catch (err) {
    return err;
  }
};

const getAllProjectList = async (data) => {
  try {
    const response = await Axios.post(`${API_URL}/dynamicFields/getProject`);
    return response;
  } catch (err) {
    return err;
  }
};

const getAllConfigurationList = async (ptype) => {
  try {
    const response = await Axios.post(
      `${API_URL}/dynamicFields/getConfiguration`,
      {
        configuration_type: ptype,
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

const setCandidate = async (data, candidateId) => {
  const date = dayjs().format("YYYY-MM-DD HH:mm:ss");
  console.log(data.data);
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/editcandidate`,
      {
        // const response = await Axios.post('http://localhost:3004/leads/editlead', {
        cid: candidateId.candidateId,
        create_dt: date,
        update_dt: date,
        cname: data.get("cname"),
        c_ccode: data.get("lccode"),
        c_mob: data.get("lmobile"),
        c_alt_ccode: data.get("alt_lccode"),
        c_alt_mob: data.get("alt_lmobile"),
        c_email: data.get("cemail"),
        source: data.get("csource"),
        position: data.get("cposition"),
        status: data.get("cstatus"),
        country: data.get("country") !== null ? data.get("country") : "null",
        state: data.get("state") !== null ? data.get("state") : "null",
        city: data.get("city"),
        locality: data.get("locality"),
        followup: data.get("followup"), 
        comments: data.get("comments"),
        followup_dt:
          data.get("followup_dt") !== null ? data.get("followup_dt") : "null",
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getCandidate = async (candidateId) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/candidateDetails`,
      {
        candidateId: candidateId,
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

const setQuickEditCandidate = async (
  data,
  candidateId,
  comments,
  name,
  number,
  pname,
  usercomments
) => {
  console.log(candidateId.candidateId);
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/quickeditcandidate`,
      {
        status: data.get("cstatus"),
        followup: data.get("followup"),
        followupdt: dayjs(data.get("followup_dt")).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        comments: comments,
        cid: candidateId.candidateId,
      }
    );
    const history = await Axios.post(`${API_URL}/desktop/candidates/createCandidateHistory`, {
      status: data.get('cstatus'),
      followup: data.get('followup'),
      followupdt: dayjs(data.get('followup_dt')).format('YYYY-MM-DD HH:mm:ss'),
      comments: comments,
      cid: candidateId.candidateId, 
      name: name,
      number: number,
      pname: pname
    });
    return response;
  } catch (err) {
    return err;
  }
};

const getLeadAssignUserList = async (candidateId) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/leads/getLeadAssignUserList`,
      {
        cid: candidateId.leadId,
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getLeadAssignUserData = async (uid, candidateId) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/leads/getLeadAssignUserData`,
      {
        uid: uid,
        cid: candidateId.leadId,
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

export {
  getAllCandidateSourceList,
  getAllCandidatePositionList,
  getAllBrokerList,
  getAllCandidateStatusList,
  getAllLeadStatusList,
  getAllProjectList,
  getAllConfigurationList,
  setCandidate,
  getCandidate,
  setQuickEditCandidate,
  getLeadAssignUserList,
  getLeadAssignUserData,
};
